import { useEffect, useState } from 'react';
import { addressSearchAvailable, searchAddresses, type AddressSuggestion } from './PropertyMap';

export function AddressSearch({ value, onChange, onSelect }: { value: string; onChange: (value: string) => void; onSelect: (suggestion: AddressSuggestion) => void }) {
  const [suggestions, setSuggestions] = useState<AddressSuggestion[]>([]);
  const [message, setMessage] = useState('');
  const [selectedValue, setSelectedValue] = useState('');
  useEffect(() => {
    setSuggestions([]); setMessage('');
    if (!addressSearchAvailable || value.trim().length < 3 || value === selectedValue) return;
    const controller = new AbortController();
    const timer = window.setTimeout(() => {
      void searchAddresses(value, controller.signal).then(items => {
        if (!controller.signal.aborted) setSuggestions(items);
      }).catch(() => {
        if (!controller.signal.aborted) setMessage('Suggestions unavailable. Manual entry still works.');
      });
    }, 450);
    return () => { window.clearTimeout(timer); controller.abort(); };
  }, [value, selectedValue]);
  return <div>
    <label htmlFor="property-address">Street address or parcel description</label>
    <input id="property-address" value={value} onChange={e => { setSelectedValue(''); onChange(e.target.value); }} autoComplete="street-address" placeholder="Address, parcel or nearby road" required />
    {suggestions.length > 0 && <div aria-label="Address suggestions">{suggestions.map(item => <button type="button" className="button secondary" key={item.id} onClick={() => {
      setSelectedValue(item.address); setSuggestions([]); onSelect(item);
    }}>{item.label}</button>)}</div>}
    {message && <small role="status">{message}</small>}
  </div>;
}
